<template>
    <div>
        <commBanner :obj="obj"></commBanner>
        <titleHead :headTitle="headTitle"></titleHead>
        <div class="w80 mb-30">
            <el-container>
                <el-aside width="330px">
                   <sidebar></sidebar>
                </el-aside>
                <el-main>
                  <headSide></headSide>
                  <!--参与活动-->
                  <div style="margin-top:30px;">
                      <contTitle :obj="obj" :contTitle="contTitle"></contTitle>
                      <div class="activity_content">
                        <div class="activity_cont fdc" v-for="(item,index) in list " :key="index">
                            <div class="w40">
                                 <img class="activity_img" :src="getImg(item.maincover)" alt="">
                            </div>
                            <div class="activity_right">
                                <p class="activity_title">{{item.maintitle}}</p>
                                <p class="activity_text">
                                    <span>{{item.mainposition}}</span>
                                    <span style="margin-left:30px;" v-if="item.createtime">{{item.createtime.substring(0,10)}}</span>
                                </p>
                            </div>
                        </div>
                      </div>

                    <!--分页-->
                    <Pagination v-show="total>0"   :total="total"  :page.sync="listQuery.curPage" :limit.sync="listQuery.limit" @pageChange="pageChange" ></Pagination>
                    <div style="margin-top:10%;">
                        <notList :notCode="notCode"></notList>
                    </div>
                  </div>
                  <!--报名活动-->
                  <div style="margin-top:30px;">
                      <contTitle :obj="obj" :contTitle="contTitle2"></contTitle>
                      <div class="activity_content">
                        <div class="activity_cont" v-for="(items,index) in expertList" :key="index">
                            <div class="w40">
                                 <img class="activity_img" :src="getImg(items.maincover)" alt="">
                            </div>
                            <div class="activity_right">
                                <p class="activity_title">{{items.maintitle}}</p>
                                <p class="activity_text">
                                    <span>{{items.mainposition}}</span>
                                    <span style="margin-left:30px;" v-if="items.createtime" >{{items.createtime.substring(0,10)}}</span>
                                </p>
                            </div>
                        </div>
                      </div>

                    <!--分页-->
                     <Pagination v-show="totals>0"   :total="totals"  :page.sync="dataQuery.curPage" :limit.sync="dataQuery.limit" @pageChange="pageChanges" ></Pagination>
                     <div style="margin-top:10%;">
                          <notList :notCode="notCodeS"></notList>
                      </div>
                  </div>
                </el-main>
            </el-container>
        </div>
    </div>
</template>
<script>
import {expertList} from '@/api/expert'
import {activityList} from "@/api/coment";
import sidebar from '../../common/sidebar'
import headSide from '../../common/headSide'
import commBanner from '../../common/commBanner'
import titleHead from  '../../common/titleHead'
import contTitle from '../../common/contTitle'
import Pagination from '../../components/Pagination'
import notList from '../../common/notList'
export default {
    components:{
        sidebar,headSide,commBanner,titleHead,contTitle,Pagination,notList
    },
    data(){
       return{
           contTitle:'参与活动',
           contTitle2:'报名活动',
           headTitle:'我的活动',
           obj:{
             title:'我的活动',   
             contCount:'',
             isShow:false,
             roleType:2,
             personalType:9,
           },
           listQuery:{
            curPage:1,
            limit:4
          },
          dataQuery:{
            curPage:1,
            limit:4
          },
         list:[], //参与
         expertList:[],
         total:0,//参与列表总条数
         totals:0, //报名列表
         notCode:false,
         notCodeS:false
       }
    },
    created(){
        this.getList();
        this.getExpert();
        if(this.$store.state.user.userInfo.type ==2){
          this.obj.roleType = 2;
         }
    },
    methods:{
        //参与
       getList(){
           activityList(this.listQuery).then(res=>{
             if(res.code ==0){
                 this.list = res.page.list;
                 this.total = res.page.list.length;
                 this.obj.contCount = res.page.totalCount;
				 this.list.length == 0 ? this.notCode = true : this.notCode = false;
             }
           }).catch(err=>{})
        },
       //报名
       getExpert(){
           expertList(this.listQuery).then(res=>{
             if(res.code ==0){
                 this.expertList = res.page.list;
                 this.totals = res.page.totalCount;
                 this.obj.contCount = res.page.totalCount;
				 this.expertList.length == 0 ? this.notCodeS = true : this.notCodeS  = false;
             }
           }).catch(err=>{})
       },
        //参与活动分页
        pageChange(item){
          this.listQuery['curPage'] = item.page;
          this.listQuery['limit'] = item.limit;
          this.getList();
        },
        //报名活动分页
        pageChange(item){
          this.dataQuery['curPage'] = item.page;
          this.dataQuery['limit'] = item.limit;
          this.getExpert();
        },
        //活动封面处理
        getImg(data){
            let url = data.split(',');
            if(url.length>2){
                return url[1]
            }else if(url.length ==1){
                return url[0]
            } 
            return ;
        }  

    },
}
</script>

<style scoped>
/* .el-aside{
    height: 800px;
} */
.mt-20{
    margin-top: 20px;
}
.w40{
    width: 40%;
    overflow: hidden;
    height: 100%;
}
.activity_content{
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 20px;
}
.activity_cont{
    width: 49%; 
    height: 120px;   
    display: flex;
    justify-content: space-between;
    border:1px solid #EEEEEE;
    margin-bottom: 20px;
}
.activity_img{
    width: 149px;
    height: 100%;
    /* height: 115px; */
    transition: all 0.6s;
}
.activity_img:hover{
    transform: scale(1.4);
}
.activity_right{
    width: 60%;;
    display: flex;
    flex-direction: column;
    height: 100%;
}
.activity_title{  
    font-size: 15px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
    line-height: 20px;
    text-align: left;
    padding:10px 15px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    height: 50px;
}
.activity_text{
    margin-top: 10px;  
    padding:15px 15px;
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #9A9A9A;
    text-align: left;
}

.el-pagination{
   margin: 60px 0px;
}

</style>
</style>


// WEBPACK FOOTER //
// src/view/expert/expert_activity.vue